import template from './template.html'

angular
  .module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternos', {
    template,
    controller: Controller,
  })
Controller.$inject = []

function Controller () {
  var $ctrl = this
  $ctrl.$onInit = $onInit

  function $onInit () {
    $ctrl.reportes = [
      {ruta: '.productosmasvendidos()', label: 'Productos más vendidos'},
      {ruta: '.saldosclientes()', label: 'Saldos de clientes'},
      {ruta: '.inventario()', label: 'Inventario'},
    ]
  }
}





// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/component.js